// extracted by mini-css-extract-plugin
export default {"imagePost":"AllPost_imagePost__jRCfF","card_post":"AllPost_card_post__FvMU5","title_text":"AllPost_title_text__DKVMg","link_post":"AllPost_link_post__YByza"};